import React, { useState, useEffect, useRef } from 'react';
import { Api } from '../../services/api';
import axios from 'axios';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';

function Profile() {
  const [userData, setUserData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedRoleId, setSelectedRoleId] = useState(1);

  const [organizations, setOrganizations] = useState([]); // State for organizations
  const [selectedOrganization, setSelectedOrganization] = useState(null); // State for selected organization

  const [isAuthorizedUser , setIsAuthorizedUser ] = useState(false); 

  const [isAdmin, setIsAdmin] = useState(false);

  const toast = useRef(null);

  useEffect(() => {
    var roleId = localStorage.getItem('role_id');
    console.log('roleId====', roleId);
    setSelectedRoleId(roleId);

    const adminStatus = localStorage.getItem('isAdmin');
    setIsAdmin(adminStatus === 'Y'); // Set isAdmin based on localStorage value

    getUser();
  }, [selectedRole]);




  const getUser = async () => {
    setLoading(true);
    const requestId = localStorage.getItem('user_id');
    const token = localStorage.getItem('authToken');
    const headers = {
      'Authorization': token ? `Bearer ${token}` : ''
    };

    try {
      const response = await axios.get(Api.API_BASE_URL + 'get-profile', { headers });
      var data = response.data.result;

      if (response.data.role_name) {
        data.role_name = response.data.role_name; // Add role_name property if present
      }

      if (response.data.rolesList) {
        data.rolesList = response.data.rolesList; // Add rolesList property if present
      }

      // Extract organizations from the response
      if (response.data.organization) {
        setOrganizations(response.data.organization); // Assuming organization data is in this path
      }

      if (data._id === "678b405eb4a77029c2ba7b8f") {
        setIsAuthorizedUser (true);
      }

      console.log('isAuthorizedUser===>>', isAuthorizedUser);
      

      setUserData(data);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = async (roleData) => {

    const token = localStorage.getItem('authToken');
    const body = {
      role_id: roleData._id,
    };

    try {
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      };

      const response = await axios.post(Api.API_BASE_URL + 'set-defualt-role', body, { headers });

      if (response.data.error !== '') {
        console.error('Error setting default role:', response.data.error);
      } else {
        localStorage.setItem('role_id', roleData._id);
        localStorage.setItem('role_name', roleData.name);
        localStorage.setItem('permission_role', roleData.permission_role);

        console.log('roleData', localStorage.getItem('permission_role'));
        setSelectedRoleId(roleData._id);
        window.location.reload();
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };

  const handleOrganizationChange = (e) => {
    setSelectedOrganization(e.value);
  };

  const handleSubmit = async () => {
    if (!selectedOrganization) {
      console.error('No organization selected');
      return;
    }

    const token = localStorage.getItem('authToken');
    const body = {
      organization_id: selectedOrganization.id, // Use the ID of the selected organization
    };

    try {
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      };

      const response = await axios.post(Api.API_BASE_URL + 'switch-user', body, { headers });

      if (response.data.error) {
        console.error('Error setting default organization:', response.data.error);
      } else {
        console.log('Default organization set successfully:', response.data);
        // Assuming the token is returned in response.data.token
        if (response.data.token) {
          localStorage.setItem('authToken', response.data.token); // Store the new token
          localStorage.setItem('user_id', response.data.userId); // Store the new token
          window.location.reload();
          toast.current.show({ severity: 'success', summary: 'Success', detail: 'Organization switched successfully!', life: 3000 });

        }
        // Optionally, you can refresh the user data or redirect the user
      }
    } catch (error) {
      console.error('Error submitting organization:', error);
    }
  };


  return (
    <>
      <Toast ref={toast} /> {/* Add Toast component */}
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (<div className="max-w-md mx-auto  rounded-xl shadow-md overflow-hidden md:max-w-2xl">
        <div className="grid grid-cols-6 gap-4 shadow p-8">
          <div className='' style={{ width: "40%" }}>
            <div className="uppercase tracking-wide text-xl text-indigo-500 font-semibold ">Profile Details</div>

            <p className="mt-6 ">Name: <span className="mt-6 text-gray-600">{userData.first_name + ' ' + userData.last_name} </span></p>
            <p className="mt-6 ">Role Name: <span className="mt-6 text-gray-600"> {userData.role_name} </span></p>

            <p className="mt-6 "> Email: <span className="mt-6 text-gray-600">{userData.email}</span></p>
            <p className="mt-6 "> Phone Number:  <span className="mt-6 text-gray-600"> {userData.phone_number}</span></p>

            <div className="mt-6">
              <label><p>Role : </p></label>

              {userData.rolesList.map((role) => (
                <div className="flex align-items-center pt-2">
                  <Checkbox inputId={'ingredient' + role.id} name="pizza" onChange={() => handleRoleChange(role)} value={role._id} checked={role._id == selectedRoleId ? true : false} />
                  <label htmlFor={'ingredient' + role.id} className="ml-2"><p>{role.name}</p></label>
                </div>
              ))}

            </div>

          </div>
          <div>
            <div className="uppercase tracking-wide text-sm text-indigo-500 font-semibold"></div>
            <p className="mt-6 ">Address:   <span className="mt-6 text-gray-600">{userData.address}</span></p>
            <p className="mt-6 ">Division:  <span className="mt-6 text-gray-600">{userData.divisionName} </span></p>
            <p className="mt-6 ">Billable Rate:  <span className="mt-6 text-gray-600">{userData.billableRate} </span></p>
            <p className="mt-6 ">Labour Burden:  <span className="mt-6 text-gray-600">{userData.labourBurden} </span></p>
            {isAdmin && isAuthorizedUser  && (
            <div className="mt-6">
              <p>Switch to Organization:</p>
              <div className='pt-2 gap-2'>
                <Dropdown
                  value={selectedOrganization}
                  options={organizations}
                  onChange={handleOrganizationChange}
                  optionLabel="title"
                  placeholder="Select an Organization"
                  className='p-2 mr-2'
                />
                <button onClick={handleSubmit} className="mt-2 copySave-button ">Submit</button>
              </div>
            </div>
             )}
          </div>
        </div>
      </div>)}
    </>

  );
}

export default Profile;
